import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  steps: [
    {
      target: '.step-notification',
      content: 'Tap the bell to receive important updates and alerts.',
      title: 'Notification bell',
      disableBeacon: true
    },
    {
      target: '.step-library',
      content:
        'Keep all your most loved documents, audio, and video files in one easily accessible place, like a personal collection.',
      title: 'Library',
      disableBeacon: true,
      placement: 'right'
    },
    // {
    //   target: '.step-history',
    //   content: 'You can check your watch history here',
    //   title: 'History',
    //   disableBeacon: true,
    //   placement: 'right'
    // },
    {
      target: '.step-favorite',
      content:
        ' Keep your most-loved documents, audio, and video files in one place for quick and easy access anytime.',
      title: 'Favourites',
      disableBeacon: true,
      placement: 'right'
    },
    {
      target: '.step-grade',
      content:
        ' Easily find and access materials based on grade level. Just select the grade you need, and all the relevant content is right there for you. It’s that simple',
      title: 'Grade wise content',
      disableBeacon: true,
      placement: 'right'
    },
    {
      target: '.step-content-card',
      content:
        'The Content section offers video, audio, and document formats for easy access to explore the material further.',
      title: 'Content',
      disableBeacon: true,
      placement: 'right'
    }
  ],
  tourStart: false
};

const joyrideSlice = createSlice({
  name: 'joyrideSlice',
  initialState,
  reducers: {
    startTour: state => {
      state.tourStart = true;
    },
    stopTour: state => {
      state.tourStart = false;
    },
    updateSteps: (state, action) => {
      state.steps = action.payload; // Allows updating tour steps dynamically
    }
  }
});

export const { startTour, stopTour, updateSteps } = joyrideSlice.actions;
export default joyrideSlice.reducer;
